<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom et Prénom</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="Last name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon2">Adresse email</span>
      </div>
      <input disabled type="email" class="form-control" placeholder="Adresse email" aria-label="Email" aria-describedby="basic-addon2">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Téléphone</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm mb-3 d-flex flex-row">
      <div class="">
        <span class="customized-span">Sexe</span>
      </div>
      <div class="ml-3">
        <div class="custom-control custom-radio custom-control-inline">
          <input checked disabled type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input">
          <label class="custom-control-label" for="customRadioInline1">Homme</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input disabled type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input">
          <label class="custom-control-label" for="customRadioInline2">Femme</label>
        </div>
      </div>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps de création</span>
      </div>
      <input disabled type="date" aria-label="First name" class="form-control">
      <input disabled type="date" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps de connexion</span>
      </div>
      <input disabled type="date" aria-label="First name" class="form-control">
      <input disabled type="date" aria-label="First name" class="form-control">
    </div>
  </form>
</template>

<script>
export default {
  name: "Read"
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/super_utilisateurs/components/Read.vue